"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactPreference = void 0;
exports.instanceOfContactPreference = instanceOfContactPreference;
exports.ContactPreferenceFromJSON = ContactPreferenceFromJSON;
exports.ContactPreferenceFromJSONTyped = ContactPreferenceFromJSONTyped;
exports.ContactPreferenceToJSON = ContactPreferenceToJSON;
exports.ContactPreferenceToJSONTyped = ContactPreferenceToJSONTyped;
/**
 *
 * @export
 */
exports.ContactPreference = {
    Text: 'TEXT',
    Email: 'EMAIL',
    Phone: 'PHONE'
};
function instanceOfContactPreference(value) {
    for (const key in exports.ContactPreference) {
        if (Object.prototype.hasOwnProperty.call(exports.ContactPreference, key)) {
            if (exports.ContactPreference[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ContactPreferenceFromJSON(json) {
    return ContactPreferenceFromJSONTyped(json, false);
}
function ContactPreferenceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ContactPreferenceToJSON(value) {
    return value;
}
function ContactPreferenceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ContactPreference.js.map